import { jsx } from "react/jsx-runtime";
import { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@perxis-auto/ui-kit/lib/components/Icon";
import "../../../entities/vehicle/api/api.js";
import "redux";
import { useAppDispatch } from "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../entities/vehicle/model/selectors/selectVehicleParameters.js";
import { useGetVehicleBenefitsChoice } from "../../../entities/vehicle/lib/useGetVehicleBenefitsChoice.js";
import "@perxis-auto/shared";
import "../../../features/benefitChoice/model/index.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "../../../shared/store/config/middleware/index.js";
import { selectBenefits } from "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import "../../../features/filterValues/api/api.js";
import "../../../features/filterValues/model/middleware/index.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAllFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValues.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesParameters.js";
import "../../../features/filterValues/model/selectors/selectAvailableFilterValuesQueries.js";
import "../../../features/filterValues/model/selectors/selectDependentFilterKeysByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableQueries.js";
import "../../../features/filterValues/model/selectors/selectFilterImmutableValues.js";
import "../../../features/filterValues/model/selectors/selectFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectFilterItems.js";
import "../../../features/filterValues/model/selectors/selectFilterValuesFields.js";
import "../../../features/filterValues/model/selectors/selectGroupedFilterItemByKey.js";
import "../../../features/filterValues/model/selectors/selectIsFilterValuesMissing.js";
import { APP } from "../../../shared/config/app.js";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import "../../../shared/store/installation/model/slice.js";
import "../../../shared/store/installation/middleware/index.js";
import "../../../entities/vehicle/model/selectors/selectIsVehiclesDataMissing.js";
import "../../../entities/vehicle/model/selectors/selectVehicle.js";
import "../../../entities/vehicle/model/selectors/selectVehicles.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesCount.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesParameters.js";
import "../../../entities/vehicle/model/selectors/selectVehiclesTotalPages.js";
import "../../../shared/context/constructor.js";
import { useThisContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import { formatBenefitsFootnoteNumber } from "../../../shared/lib/format/benefit/formatBenefitsFootnoteNumber.js";
import { getCompatibleBenefits } from "../../../shared/lib/format/benefit/getCompatibleBenefits.js";
import { formatVehicleBenefits } from "../../../shared/lib/format/vehicle/formatVehicleBenefits.js";
import "../../../shared/lib/logger/index.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import { actions } from "../../../features/benefitChoice/model/slice.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const { t } = useTranslation(APP.name);
  const dispatch = useAppDispatch();
  const vehicleItem = useThisContext();
  const benefitsConfig = useAppSelector(selectBenefits);
  const vehicleId = vehicleItem == null ? void 0 : vehicleItem.id;
  const benefits = useMemo(() => vehicleItem ? formatVehicleBenefits(vehicleItem) : [], [vehicleItem]);
  const maxBenefit = vehicleItem == null ? void 0 : vehicleItem.data.maxBenefit;
  const price = vehicleItem == null ? void 0 : vehicleItem.data.price;
  const selectedBenefits = useGetVehicleBenefitsChoice(vehicleItem);
  const totalBenefit = selectedBenefits.reduce((amount, b) => amount + b.value, 0);
  const priceWithBenefit = price ? price - totalBenefit : 0;
  const onSelectChange = useCallback(
    (e, benefitId) => {
      if (!vehicleId || !benefits || benefits.length === 0) {
        return null;
      }
      const benefit = benefits.find((b) => b.id === benefitId);
      if (!benefit) {
        return null;
      }
      if (e.target.checked) {
        const compatibleBenefits2 = getCompatibleBenefits(benefits, benefit, selectedBenefits);
        const selectedBenefitsWithoutIncompatible = selectedBenefits.filter(
          (selectedBenefit) => compatibleBenefits2.some((compatibleBenefit) => compatibleBenefit === selectedBenefit)
        );
        dispatch(
          actions.setOne({
            id: vehicleId,
            benefits: [...selectedBenefitsWithoutIncompatible, benefit]
          })
        );
        return;
      }
      const updatedSelectedBenefits = selectedBenefits.filter((b) => b !== benefit);
      dispatch(
        actions.setOne({
          id: vehicleId,
          benefits: updatedSelectedBenefits
        })
      );
    },
    [vehicleId, benefits, selectedBenefits, dispatch]
  );
  const compatibleBenefits = useMemo(() => {
    if (!benefits) {
      return [];
    }
    if (!selectedBenefits.length) {
      return benefits;
    }
    const lastSelectedBenefit = selectedBenefits[selectedBenefits.length - 1];
    const previouslySelectedBenefits = selectedBenefits.slice(0, selectedBenefits.length - 1);
    const compatibleBenefits2 = getCompatibleBenefits(benefits, lastSelectedBenefit, previouslySelectedBenefits);
    return [lastSelectedBenefit, ...compatibleBenefits2];
  }, [benefits, selectedBenefits]);
  const getMaxBenefit = useCallback(() => {
    if (!maxBenefit || !maxBenefit.length || !benefits) {
      return 0;
    }
    const amount = maxBenefit.reduce((amount2, maxBenefit2) => {
      const benefit = benefits.find((b) => b.id === maxBenefit2.id);
      if (!benefit) {
        return amount2;
      }
      return amount2 + benefit.value;
    }, 0);
    return amount;
  }, [benefits, maxBenefit]);
  const title = useMemo(
    () => ({
      label: benefitsConfig.title,
      icon: /* @__PURE__ */ jsx(Icon, { name: "service-discount", sticker: "benefits-title-icon" })
    }),
    [benefitsConfig.title]
  );
  const header = useMemo(
    () => [
      {
        id: 0,
        label: benefitsConfig.retailPrice,
        value: t("format.currency", { value: price })
      }
    ],
    [benefitsConfig.retailPrice, price, t]
  );
  const items = useMemo(() => {
    const isBenefitIncompatible = (benefitId) => !compatibleBenefits.some((b) => b.id === benefitId);
    const isBenefitSelected = (benefitId) => {
      return selectedBenefits.some((b) => b.id === benefitId);
    };
    const getFootnoteNumberById = (benefitId) => {
      const benefit = benefits == null ? void 0 : benefits.find((b) => b.id === benefitId);
      if (!benefit || !benefits) {
        return void 0;
      }
      return formatBenefitsFootnoteNumber(benefits, benefit) || void 0;
    };
    return benefits.map(({ displayName, value, id }) => ({
      id,
      value: benefitsConfig.showAmount ? t("format.currency", { value }) : null,
      label: displayName,
      selected: isBenefitSelected(id),
      incompatible: isBenefitIncompatible(id),
      footnoteNumber: getFootnoteNumberById(id)
    }));
  }, [benefits, benefitsConfig.showAmount, compatibleBenefits, selectedBenefits, t]);
  const subtotal = useMemo(
    () => [
      {
        id: 0,
        label: benefitsConfig.totalBenefit,
        value: t("format.currency", { value: totalBenefit })
      },
      {
        id: 1,
        label: benefitsConfig.priceWithBenefit,
        value: t("format.currency", { value: priceWithBenefit })
      }
    ],
    [benefitsConfig.priceWithBenefit, benefitsConfig.totalBenefit, priceWithBenefit, t, totalBenefit]
  );
  const footer = useMemo(
    () => ({
      text: `${benefitsConfig.maxBenefit}${t("format.currency", {
        value: getMaxBenefit()
      })}`
    }),
    [benefitsConfig.maxBenefit, getMaxBenefit, t]
  );
  return {
    ...props,
    title,
    header,
    items,
    onSelectChange,
    subtotal,
    footer
  };
};
export {
  useContainer
};
